import shortcut from '../../utils/shortcut';

export default class ShortcutController {
  constructor(game) {
    this.game = game;
    if (__SHORTCUTS_ENABLED__ || window.location.href.includes('dev-scoobytravel')) {
      shortcut('↑ ↑ ↓ ↓ ← →', {
        done: this.handleOpenCheatWindow.bind(this),
        description: '[↑ ↑ ↓ ↓ ← →] Open Cheat Window',
      });
      shortcut('↑ ↓ ↑ ↓', {
        done: this.handleSkipGame.bind(this),
        description: '[↑ ↓ ↑ ↓] Skip Mini Game ( during game )',
      });
    }
  }

  handleOpenCheatWindow() {
    this.game.gameController.cheats.openWindow();
  }

  handleSkipGame() {
    if (this.game.gameController.isPlayingMiniGame()) {
      this.game.gameController.endMiniGame();
    }
  }
}



// WEBPACK FOOTER //
// ./js/app/controller/ShortcutController.js